var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReferrals = function SvgReferrals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.32117 11.3728L4.36459 15.2832C4.24907 15.3975 4.15737 15.5335 4.09479 15.6834C4.03222 15.8332 4 15.9939 4 16.1563C4 16.3186 4.03222 16.4793 4.09479 16.6292C4.15737 16.779 4.24907 16.915 4.36459 17.0293L6.97766 19.6363C7.09225 19.7515 7.22857 19.843 7.37877 19.9054C7.52897 19.9678 7.69008 20 7.85279 20C8.01551 20 8.17661 19.9678 8.32681 19.9054C8.47702 19.843 8.61334 19.7515 8.72792 19.6363L12.6475 15.689",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.716 12.6272L19.6356 8.7168C19.7511 8.60249 19.8428 8.46649 19.9054 8.31664C19.968 8.16679 20.0002 8.00606 20.0002 7.84373C20.0002 7.6814 19.968 7.52067 19.9054 7.37083C19.8428 7.22098 19.7511 7.08497 19.6356 6.97066L17.0595 4.36374C16.9449 4.24848 16.8086 4.157 16.6584 4.09457C16.5082 4.03214 16.3471 4 16.1844 4C16.0217 4 15.8606 4.03214 15.7104 4.09457C15.5602 4.157 15.4238 4.24848 15.3093 4.36374L11.3896 8.31101",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.485 9.54053L9.55469 14.4592",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgReferrals;